import { Observable } from '../tools/observable';
export const TrackingConsent = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted',
};
export function createTrackingConsentState(currentConsent) {
    const observable = new Observable();
    function isGranted() {
        return currentConsent === TrackingConsent.GRANTED;
    }
    return {
        tryToInit(trackingConsent) {
            if (!currentConsent) {
                currentConsent = trackingConsent;
            }
        },
        onGrantedOnce(fn) {
            if (isGranted()) {
                fn();
            }
            else {
                const subscription = observable.subscribe(() => {
                    if (isGranted()) {
                        fn();
                        subscription.unsubscribe();
                    }
                });
            }
        },
        update(trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted,
        observable,
    };
}
//# sourceMappingURL=trackingConsent.js.map